import React, { useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  loadingToggleAction,
  loginAction,
  loginConfirmedAction,
} from "../../../store/actions/AuthActions";
import logoFull from "../../../assets/images/rajdhani.png";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import TElogo from "../../../assets/images/logopng13.png";
import TElogo from "../../../assets/images/logopng-17.png";

function ChangePassword(props) {
  const [email, setEmail] = useState();
  let errorsObj = { email: "", password: "" };
  const [errors, setErrors] = useState(errorsObj);
  const [password, setPassword] = useState();
  const [submitted, setSubmitted] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Validation logic
  const validateFields = () => {
    const errorObj = { email: "", password: "" };
    let isError = false;
    if (!email) {
      errorObj.email = "Email is required";
      isError = true;
    }
    if (!password) {
      errorObj.password = "Password is required";
      isError = true;
    }
    setErrors(errorObj);
    return isError;
  };

  // Reset the specific error when the user starts typing
  const handleInputChange = (e, field) => {
    if (field === "email") {
      setEmail(e.target.value);
      if (submitted && errors.email) {
        setErrors((prevErrors) => ({ ...prevErrors, email: "" }));
      }
    } else if (field === "password") {
      setPassword(e.target.value);
      if (submitted && errors.password) {
        setErrors((prevErrors) => ({ ...prevErrors, password: "" }));
      }
    }
  };

  function onLogin(e) {
    e.preventDefault();
    setSubmitted(true);
    // Validate fields
    if (validateFields()) {
      return;
    }
    dispatch(loadingToggleAction(true));
    dispatch(loginAction(email, password, navigate));

    // const res = login(email, password, navigate);
    // console.log("response from login component");
    // if (res) {
    // 	navigate('/dashboard');
    // 	dispatch(loginConfirmedAction(res));
    // } else {
    // 	console.log("Login not successfully done");
    // }
  }

  return (
    <>
      <ToastContainer />
      <div className="fix-wrapper py-0">
        <div className="w-100">
          <div className="row login-mainsection-background">
            {/* <div className="d-none d-lg-block col-lg-6 col-md-5 p-0">
              <div className="left-section position-relative overflow-hidden">
                <video
                  className="df-video"
                  height="100vh"
                  autoPlay
                  muted
                  loop
                  controls={false}>
                  <source src={dfVideo} type="video/mp4" />
                </video>
                <div>
                  <h4 className="login-left-section-text">
                    Welcome to <br/> Digital Fusion
                  </h4>
                </div>
              </div>
            </div> */}
            <div className="col-12 col-lg-12 login-right-section d-flex flex-column justify-content-center">
              <div className=" login-right-content-section">
                <div className="card login-card mb-0 h-auto">
                  <div className="card-body">
                    {/* logo */}
                    <div className="d-flex justify-content-center mb-2">
                      <Link to={"/dashboard"}>
                        <img
                          src={TElogo}
                          alt="logo"
                          style={{ height: "80px", width: "auto" }}
                        />
                      </Link>
                    </div>
                    {/* Tag or intro Line */}
                    <h4 className="login-welcome-text">Welcome back Admin !</h4>
                    <h4 className=" mb-4">Sign in to your account</h4>

                    {/* Form */}
                    <form onSubmit={onLogin}>
                      {/* <div className="mb-3">
                        <label className="mb-1 text-dark">
                          <strong>Email</strong>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          value={email}
                          // onChange={(e) => setEmail(e.target.value)}
                          onChange={(e) => handleInputChange(e, "email")}
                          placeholder="Type Your Email Address"
                        />
                        {errors.email && (
                          <div className="text-danger fs-12">
                            {errors.email}
                          </div>
                        )}
                      </div> */}
                      <div className="mb-2">
                        <label className="mb-1 text-dark">
                          <strong>Password</strong>
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          value={password}
                          placeholder="Type Your Password"
                          onChange={(e) => handleInputChange(e, "password")}
                        />
                        {errors.password && (
                          <div className="text-danger fs-12">
                            {errors.password}
                          </div>
                        )}
                      </div>

                      {props.successMessage && (
                        <div className="text-danger p-1 my-2">
                          {props.successMessage}
                        </div>
                      )}

                      <div className="row d-flex justify-content-between mt-0 mb-0">
                        <div className="mb-3">
                          <div className="d-flex justify-content-between form-check custom-checkbox ms-1 ps-0 ">
                           <Link className="text-dark" to="/user/login">Login as User</Link>
                           <Link className="text-dark" to="/verification">Verification</Link>
                           <Link className="text-dark" to="/forgotpassword">Forgot Password</Link>
                          </div>
                        </div>
                      </div>
                        {/* <div className="row d-flex justify-content-between mt-4 mb-2">
                          <div className="mb-3">
                            <div className="form-check custom-checkbox ms-1">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="basic_checkbox_1"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="basic_checkbox_1">
                                Remember my preference
                              </label>
                            </div>
                          </div>
                        </div> */}
                      <div className="text-center">
                        <button
                          type="submit"
                          className="btn text-white btn-block handle-login-btn">
                           Continue
                        </button>
                      </div>
                    </form>
                    {/* Button for signup and forgot password */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ChangePassword;
